module.exports = __webpack_public_path__ + "img/c52d13d.png";